<template>
  <b-row>
    <b-col>
      <chartjs-container title="Statistiques des appels par jour">
        <chartjs-component-bar-chart v-if="!noDailyData && dailyChartData.datasets" :height="chartHeight" :chart-data="dailyChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
    <b-col>
      <chartjs-container title="Statistiques des appels par heure">
        <chartjs-component-bar-chart v-if="!noHourlyData && hourlyChartData.datasets" :height="chartHeight" :chart-data="hourlyChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
    <b-col>
      <chartjs-container :title="chartTitle">
        <chartjs-component-bar-chart v-if="hasMeaningfulData" :height="chartHeight" :chart-data="chartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol,
  BRow,
} from 'bootstrap-vue'
import ChartjsContainer from '../ChartjsContainer.vue'
import ChartjsComponentBarChart from '../charts-components/ChartjsComponentBarChart.vue'
import useStatisticsRouteFetch from '../useStatisticsRouteFetch'
import {
  computedConfiguration,
  watchConfiguration,
  BASE_CHART_HEIGHT,
  chartHasMeaningfulData,
} from './baseConfiguration'

export default {
  components: {
    BCol,
    BRow,
    ChartjsContainer,
    ChartjsComponentBarChart,
  },
  data() {
    return {
      tabname: 'CallInflux',
      chartTitle: 'Affluence des appels par heure et jour',
      chartData: {},
      chartHeight: BASE_CHART_HEIGHT,
      dailyChartData: {},
      hourlyChartData: {},
      noDailyData: false,
      noHourlyData: false,
    }
  },
  computed: {
    ...computedConfiguration,
    hasMeaningfulData() {
      return chartHasMeaningfulData(this.chartData)
    },
  },
  watch: watchConfiguration,
  methods: {
    fetchRouteOnActive() {
      if (this.active) {
        this.fetchRoute()
      }
    },
    async fetchRoute() {
      const response = await useStatisticsRouteFetch(0, 'CallInflux')
      this.noDailyData = !response.callsByDay || Object.keys(response.callsByDay).length === 0
      this.noHourlyData = !response.callsByHour || Object.keys(response.callsByHour).length === 0
      this.buildChart(response.callsByDayAndHour)
      this.buildDailyChart(response.callsByDay)
      this.buildHourlyChart(response.callsByHour)
    },
    buildDailyChart(callsByDay) {
        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
        const dayTranslations = {
 Monday: 'Lundi', Tuesday: 'Mardi', Wednesday: 'Mercredi', Thursday: 'Jeudi', Friday: 'Vendredi', Saturday: 'Samedi', Sunday: 'Dimanche',
}
        const colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#E7E9ED']
        const values = days.map(day => callsByDay[day]?.Total || 0)
        this.dailyChartData = {
            labels: days.map(day => dayTranslations[day]),
            datasets: [
                {
                    label: 'Appels reçus par jour',
                    data: values,
                    backgroundColor: days.map((_, i) => colors[i % colors.length]),
                    barPercentage: 0.9,
                    categoryPercentage: 0.9,
                },
            ],
        }
    },
    buildHourlyChart(callsByHour) {
        const hours = Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}h`)
        const data = hours.map(hour => callsByHour[hour]?.Total || 0)
        const colors = [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40',
        '#E7E9ED', '#C9CBFF', '#FF6399', '#36AEEB', '#FFCE99', '#4BC0C0',
        '#9966FF', '#FF9F40', '#E7E9ED', '#C9CBBF', '#FF6322', '#36A2EB',
        '#FFCE56', '#4BC040', '#9966FF', '#FF9F40', '#E7E9ED', '#C9CBCF',
      ]

        this.hourlyChartData = {
            labels: hours,
            datasets: [{
                label: 'Appels par heure',
                data,
                backgroundColor: colors,
                barPercentage: 0.5,
                categoryPercentage: 0.7,
            }],
        }
    },

    buildChart(callsByDayAndHour) {
        const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
        const allHours = Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}h`)
        const colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#E7E9ED']
        const dayTranslations = {
        Monday: 'Lundi', Tuesday: 'Mardi', Wednesday: 'Mercredi', Thursday: 'Jeudi', Friday: 'Vendredi', Saturday: 'Samedi', Sunday: 'Dimanche',
        }
        const datasets = allDays.map((day, index) => {
            const hourlyData = allHours.map(hour => callsByDayAndHour?.[day]?.[hour] || 0)
            return {
                label: dayTranslations[day],
                data: hourlyData,
                backgroundColor: colors[index],
            }
        })
        this.chartData = {
            labels: allHours,
            datasets,
        }
    },
  },
}
</script>
